<script>

import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {},
  props: {
    newspaper: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  beforeMount() {
  },
  methods: {
    async submitForm() {
      api.save('newspapers', this.newspaper)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
  }
};
</script>

<template>

  <b-form>
    <b-card no-body class="mb-2 pt-2">
      <b-card-body class="p-0">
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Fichier" label-for="formrow-filename-input">
              <b-form-input id="formrow-filename-input" type="text"
                            v-model="newspaper.filename"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Texte" label-for="formrow-text-input">
              <b-form-textarea
                  id="formrow-text-input"
                  v-model="newspaper.text"
                  rows="5"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>